import { Theme } from '@mui/material/styles'

const useStyles = {
  container: (theme: Theme) => ({
    borderWidth: '1px',
    borderStyle: 'solid',
    padding: theme.spacing(0.5, 1),
    lineHeight: '20px',
    borderRadius: theme.shape.borderRadius,
  }),
}
export default useStyles
